"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentBuilder = void 0;
const dcl_catalyst_commons_1 = require("dcl-catalyst-commons");
class DeploymentBuilder {
    /**
     * As part of the deployment process, an entity has to be built. In this method, we are building it, based on the data provided.
     * After the entity is built, the user will have to sign the entity id, to prove they are actually who they say they are.
     */
    static async buildEntity(type, pointers, files = new Map(), metadata, timestamp) {
        // Reorder input
        const contentFiles = Array.from(files.entries()).map(([name, content]) => ({ name, content }));
        // Calculate hashes
        const hashes = await dcl_catalyst_commons_1.Hashing.calculateHashes(contentFiles);
        const hashesByKey = new Map(hashes.map(({ hash, file }) => [file.name, hash]));
        const filesByHash = new Map(hashes.map(({ hash, file }) => [hash, file]));
        return DeploymentBuilder.buildEntityInternal(type, pointers, { hashesByKey, filesByHash, metadata, timestamp });
    }
    /**
     * In cases where we don't need upload content files, we can simply generate the new entity. We can still use already uploaded hashes on this new entity.
     */
    static async buildEntityWithoutNewFiles(type, pointers, hashesByKey, metadata, timestamp) {
        return DeploymentBuilder.buildEntityInternal(type, pointers, { hashesByKey, metadata, timestamp });
    }
    static async buildEntityInternal(type, pointers, options) {
        var _a, _b, _c;
        // Make sure that there is at least one pointer
        if (pointers.length === 0) {
            throw new Error(`All entities must have at least one pointer.`);
        }
        // Re-organize the hashes
        const hashesByKey = (_a = options === null || options === void 0 ? void 0 : options.hashesByKey) !== null && _a !== void 0 ? _a : new Map();
        const entityContent = Array.from(hashesByKey.entries()).map(([key, hash]) => ({
            file: key,
            hash
        }));
        // Calculate timestamp if necessary
        const timestamp = (_b = options === null || options === void 0 ? void 0 : options.timestamp) !== null && _b !== void 0 ? _b : (await DeploymentBuilder.calculateTimestamp());
        // Build entity file
        const { entity, entityFile } = await dcl_catalyst_commons_1.buildEntityAndFile(type, pointers, timestamp, entityContent, options === null || options === void 0 ? void 0 : options.metadata);
        // Add entity file to content files
        const filesByHash = (_c = options === null || options === void 0 ? void 0 : options.filesByHash) !== null && _c !== void 0 ? _c : new Map();
        filesByHash.set(entity.id, entityFile);
        return { files: filesByHash, entityId: entity.id };
    }
    static async calculateTimestamp() {
        // We will try to use a global time API, so if the local PC clock is off, it will still work
        const fetcher = new dcl_catalyst_commons_1.Fetcher();
        try {
            const { datetime } = await fetcher.fetchJson('https://worldtimeapi.org/api/timezone/Etc/UTC');
            return new Date(datetime).getTime();
        }
        catch (e) {
            return Date.now();
        }
    }
}
exports.DeploymentBuilder = DeploymentBuilder;
//# sourceMappingURL=DeploymentBuilder.js.map